import { VideoElementRenderer, VideoRendererHost } from './video-renderer';

// A finished recording served as one file (MP4 with Range): the browser
// plays and seeks it natively.
export class FileRenderer extends VideoElementRenderer {
  private readonly onError = (): void => this.host.onFatal('file not playable', true);

  constructor(video: HTMLVideoElement, host: VideoRendererHost, private readonly url: string) {
    super(video, host);
  }

  public start(): void {
    this.observeVideo();
    this.video.addEventListener('error', this.onError);
    this.video.src = this.url;
    this.play();
  }

  public override destroy(): void {
    this.video.removeEventListener('error', this.onError);
    super.destroy();
  }
}
